import builderPathInit from '../../../util/builder-path-init';
import { builder } from '@builder.io/react/lite';
import getConfig from 'next/config';
const pathPrefix = '/blog/article';
const model = 'blog-article';

const {
  publicRuntimeConfig: { GF_DOTCOM_ENV },
} = getConfig();

const builderComponentQuery =
  GF_DOTCOM_ENV === 'production'
    ? {
        query: {
          data: {
            environment: GF_DOTCOM_ENV ?? 'production',
          },
        },
      }
    : {};

const { BuilderPage } = builderPathInit({
  model: model,
});

export default BuilderPage;

export async function getServerSideProps(context) {
  const {
    params: { id },
  } = context;
  const urlPath = id ? `${pathPrefix}/${id}` : pathPrefix;
  const content = await builder
    .get(model, {
      userAttributes: {
        urlPath,
        ...builderComponentQuery,
      },
      options: { enrich: true, includeRefs: true },
    })
    .promise();
  if (!content) {
    return {
      notFound: true,
    };
  }

  const { title } = content?.data;
  return {
    props: {
      content,
      title,
    },
  };
}
